<z-select
    id="{{ id() }}"
    [options]="options()"
    [style]="inputStyle()"
    [optionLabel]="optionLabel()"
    [optionValue]="optionValue()"
    [placeholder]="placeholder()"
    [label]="label()"
    [class]="class"
    [filter]="false"
    [showClear]="false"
    [disabled]="disabled"
    [(ngModel)]="model"
    [readonly]="readonly()"
    (ngModelChange)="onModelChange($event)"
    [ngModelOptions]="{ standalone: true }"
/>
